interface MatomoWindow extends Window {
  _paq?: unknown[];
}

const MATOMO_BASE_URL = "https://matomo.aalen.space/";
const MATOMO_SITE_ID = "1";

/** Loads Matomo. Only call this once the visitor has given consent. */
export function initAnalytics(): void {
  const w = window as MatomoWindow;
  const paq = (w._paq = w._paq || []);
  paq.push(["setDocumentTitle", `${document.domain}/${document.title}`]);
  paq.push(["setCookieDomain", "*.aalen.space"]);
  paq.push(["trackPageView"]);
  paq.push(["enableLinkTracking"]);
  paq.push(["setTrackerUrl", `${MATOMO_BASE_URL}matomo.php`]);
  paq.push(["setSiteId", MATOMO_SITE_ID]);

  const script = document.createElement("script");
  script.async = true;
  script.src = `${MATOMO_BASE_URL}matomo.js`;
  document.head.appendChild(script);
}

/**
 * Tells an already-loaded Matomo tracker to stop sending data. The script itself
 * can't be unloaded once injected, so withdrawing consent mid-session (via the
 * "Cookie-Einstellungen" banner) relies on Matomo's own opt-out command instead.
 */
export function optOutAnalytics(): void {
  const w = window as MatomoWindow;
  const paq = (w._paq = w._paq || []);
  paq.push(["optUserOut"]);
}
